<template>
  <div class="signin">
    <van-nav-bar title="" fixed left-arrow @click-left="goBack" @click-right="onClickRight">
      <!--<van-icon slot="right" class="iconfont icon-zhankai"></van-icon>-->
    </van-nav-bar>
    <div class="van-content">
      <div class="signintop">
        <div class="signintopimg" @click="signinPlay()" v-if="datas.sign_flag == 0">
          <p class="ft4">签到</p>
          <!--<p class="ft2"><span class="ft3">+5</span> {{ configData.integral_name }}</p>-->
        </div>
        <div class="signintopimg" v-else="datas.sign_flag == 1">
          <p class="ft4">已签到</p>
          <p class="ft2"><span class="ft3">+{{sign_today_points}}</span> {{ configData.integral_name }}</p>
        </div>
        <p class="ft2" v-if="datas.sign_flag == 0">今天还没有签到，赶紧签到领积分吧！</p>
        <p class="ft2" v-else="datas.sign_flag == 1">已连续签到{{ sign_nums }}天，明日签到得{{sign_tomorrow_points}}{{ configData.integral_name }}！</p>
      </div>
      <vue-event-calendar :events="demoEvents" @monthChanged="" @dayChanged="">
        <template slot-scope="props">
          <div></div>
        </template>
      </vue-event-calendar>
      <div class="siginbot">
        <div class="text-cent">
          <p class="title">签到规则</p>
        </div>
        <ol>
          <li>会员必须登录成功后才可进行签到活动，每人每天最多签到一 次。</li>
          <li>签到以自然月为单位，若中途签到中断或者连续签到1个月的，则从第一天开始重新计算。</li>
          <li v-if="configData.sign_content != ''" v-html="configData.sign_content"></li>
        </ol>
      </div>
      <van-popup v-model="show">
        <div class="signCont">
          <div class="fontCont">
            <p class="firstLine"><span class="getPoint">+{{ sign_toast_points }}</span>{{ configData.integral_name }}</p>
              <p>明天签到可获得 <span class="col-e4153b">{{sign_tomorrow_points}}</span> {{ configData.integral_name }}</p>
          </div>
        </div>
    	</van-popup>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import TopNav from "@/components/topnav";
import "vue-event-calendar/dist/style.css"; //1.1.10之后的版本，css被放在了单独的文件中，方便替换
import vueEventCalendar from "vue-event-calendar";
Vue.use(vueEventCalendar); //可以设置语言，支持中文和英文

export default {
  name: "signin",
  props: ["userConfig", "configData"],
  data() {
    return {
      datas: [],
      sign_nums: 0,
      sign_total_points: "0",
      sign_today_points: "0",
      sign_tomorrow_points: "0",
      sign_toast_points: "0",
      show: false,
      demoEvents: [
        {
          date: "2016/12/15",
          title: "eat",
          desc: "longlonglong description"
        },
        {
          date: "2016/11/12",
          title: "this is a title"
        }
      ]
    };
  },
  components: {
    TopNav
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay();
    },
    getDatas() {
      var _this = this;
      var isUser = localStorage.getItem("BLHuser");
      this.$api.post("WebApi/Member/Sign/index", { token: isUser }, res => {
        this.datas = res.data.data;
        this.sign_nums = res.data.data.sign_info.sign_nums;
        this.sign_today_points = res.data.data.today_points;
        this.sign_tomorrow_points = res.data.data.tomorrow_sign_points;
        $.each(res.data.data.sign_info.day_data, function(index, items) {
          var a = new Date(items.add_time).getDate();
          $.each($(".dates .item"), function(index, items) {
            if (
              a ==
              $(items)
                .find(".date-num")
                .text()
            ) {
              $(items)
                .find(".date-num")
                .addClass("theme-col");
            }
          });
        });
      });
    },
    signinPlay() {
      var isUser = localStorage.getItem("BLHuser");
      this.$api.post("WebApi/Member/Sign/sign", { token: isUser }, res => {
        if (res.data.code == "100") {
          this.sign_toast_points = res.data.data.point;
          this.getDatas();
          this.show = true;
          this.datas.sign_flag = 1;
        } else if (res.data.errCode == "1002") {
          this.$dialog
            .confirm({
              title: "提示",
              message: "您还未登录是否去登录？"
            })
            .then(() => {
              this.$router.push({ path: "/notelogin" });
            })
            .catch(() => {
              // on cancel
            });
        } else {
          this.$toast(res.data.message);
        }
      });
    }
  },
  mounted() {
    var _this = this;
    this.getDatas();
    $(".today").click(function() {
      _this.signinPlay();
    });
  }
};
</script>

<style lang="less">
#app {
  .signin {
    min-height: 100vh;
    background: linear-gradient(#ff8a69, #f83e64);
    .van-nav-bar {
      background-color: inherit;
      .van-nav-bar__title,
      .van-icon {
        color: #fff;
      }
    }
    .van-nav-bar.van-hairline--bottom::after {
      border-bottom-width: 0;
    }
    .van-content {
      padding: 46px 20px 40px;
      .siginbot {
        padding: 0 15px;
        p,
        li {
          color: #fff;
          text-align: justify;
        }
        .title {
          font-size: 1.6rem;
          text-align: center;
          background-image: url("/static/images/signintitbg.png");
          background-size: 100% 100%;
          padding: 0px 70px;
          display: inline-block;
          margin: 15px 0;
        }
        ol {
          list-style: decimal;
        }
      }
      .signintop {
        text-align: center;
        margin-bottom: 20px;
        .signintopimg {
          display: inline-block;
          background-image: url("/static/images/signinimg1.png");
          background-size: 100% 100%;
          padding: 40px;
        }
        p {
          color: #fff;
        }
      }
      .__vev_calendar-wrapper {
        background-image: url("/static/images/signinbanner.png");
        background-size: 100% 100%;
        padding: 0 30px;
        box-sizing: border-box;
        .events-wrapper,
        .l,
        .r {
          display: none;
        }
        .cal-header {
          background-color: inherit;
          padding: 0;
          .title {
            width: 100%;
            padding: 15px 0 0;
            font-size: 1.6rem;
            color: #000;
          }
        }
      }
      .__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item .date-num {
        font-size: 1.5rem;
      }
      .__vev_calendar-wrapper .cal-wrapper .cal-body .dates .today .date-num {
        color: #fff !important;
      }
      .__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item .is-today {
        width: 30px;
        height: 30px;
        left: 50%;
        top: 50%;
        margin-left: -15px;
        margin-top: -15px;
        color: #fff;
        background-color: #fb5966 !important;
      }
      .signCont {
        width: 250px;
        height: 250px;
        margin: -100px 0 0 0;
        background: url("/static/images/signOk.png") no-repeat center;
        background-size: 100% 100%;
      }
      .van-popup {
        background-color: transparent !important;
      }
      .van-modal {
        background-color: rgba(0, 0, 0, 0.7) !important;
      }
      .fontCont {
        text-align: center;
        position: absolute;
        bottom: 35px;
        left: 52px;
        font-size: 12px;
        color: #666;
      }
      .getPoint {
        font-size: 16px;
        color: #e4153b;
        margin-right: 5px;
      }
      .col-e4153b {
        color: #e4153b;
      }
      .firstLine {
        margin-bottom: 10px;
      }
      .today .date-num.theme-col {
        background: url("/static/images/whiteDot.png") no-repeat;
        background-position-x: center;
        background-position-y: 29px;
        background-size: 5px 5px;
      }
      .date-num.theme-col {
        background: url("/static/images/reDot.png") no-repeat;
        background-position-x: center;
        background-position-y: 29px;
        background-size: 5px 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/signin.vue